import { FormatNumberOptions, FormattedNumber } from 'react-intl';

import { DEFAULT_CURRENCY, type MoneyInfo, toMoneyInfo } from 'restful/tickets';

interface Props extends FormatNumberOptions {
  price: MoneyInfo | number | undefined;
}

const FormattedMoneyInfo = ({
  price,
  currency = DEFAULT_CURRENCY,
  ...options
}: Props) => {
  if (!price) return null;
  const moneyInfo = toMoneyInfo(price, currency);
  if (!moneyInfo) return null;

  return (
    <FormattedNumber
      value={moneyInfo.amount}
      currency={moneyInfo.currency}
      style="currency"
      minimumFractionDigits={2}
      {...options}
    />
  );
};

export default FormattedMoneyInfo;
